import usePermissions, { ManagerRole } from '../auth/usePermissions';
import useIsPartnerStaff from '../auth/useIsPartnerStaff';

/**
 * Whether this login may buy a licence: a partner admin, or a super admin
 * acting for one — the same rule the activate route enforces. A restaurant
 * user never may: the partner resells licences at its own price, so no
 * FoodAmigos price, trial or plan name may reach them (WLP, 2026-09-25).
 */
export default function useMayPurchaseLicense() {
  const { isSuperAdmin, hasAnyRole } = usePermissions();
  const isPartnerStaff = useIsPartnerStaff();

  return isSuperAdmin || (isPartnerStaff && hasAnyRole([ManagerRole.Admin], false));
}
